import { WETLANDS, WETLANDSALL } from "actions/wetlands";
import { reducerPackage } from "../../utils";

export const wetlands = reducerPackage(WETLANDS);
export const wetlandsAllList = reducerPackage(WETLANDSALL);
